import { IStamped } from "./base/IStamped";
import { IHydratable } from "./base/IHydratable";

interface ISpecies extends IStamped, IHydratable {
  name: string;
  // Null when AquaFish/AquaShell has no growth model for this species, which
  // means it cannot be simulated or chosen for a project.
  modelCode: number | null,
  // Culture defaults from ORGANIX, read live rather than snapshotted so a
  // correction reaches every project. harvestWeight is a reference value: no
  // model reads it.
  initialWeight: number | null,
  culturePeriod: number | null,
  harvestWeight: number | null,
  genus: string;
  species: string;
  nameUK: string;
  nameUS: string;
  nameNO: string;
  nameFR: string;
  nameES: string;
  nameIT: string;
  namePT: string;
  nameZH: string;
}

/**
 * AquaShell model codes occupy 1000-1099 and AquaFish 2000-2500, so the code
 * itself says which model a species belongs to and no separate column is needed.
 * A null modelCode cannot be classified, but such a species can never be
 * simulated or selected either.
 */
const isShellfishModel = (modelCode: number): boolean => modelCode < 2000;

export { ISpecies, isShellfishModel }
